import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/social`

console.log('serverUrl', serverUrl)

export const addSocialMediaApi = (formData) => {
    return axiosInstance.post(`${serverUrl}/addSocial`, formData)
}

export const getSocialMediaApi = (query = "") => {
    return axiosInstance.get(`${serverUrl}/`)
}

export const getSocialMediaByIdApi = (id) => {
    return axiosInstance.get(`${serverUrl}/${id}`)
}

export const updateSocialMediaApi = (id, formData) => {
    return axiosInstance.put(`${serverUrl}/updateSocial/${id}`, formData)
}

export const updateSocialMediaStatusApi = (id, formData) => {
    return axiosInstance.put(`${serverUrl}/updateStatusById/${id}`, formData)
}

export const deleteSocialMediaApi = (id) => {
    return axiosInstance.delete(`${serverUrl}/deleteById/${id}`)
}

const SocialMediaService = {
    addSocialMedia: addSocialMediaApi,
    getSocialMedias: getSocialMediaApi,
    getSocialMediaById: getSocialMediaByIdApi,
    updateSocialMedia: updateSocialMediaApi,
    deleteSocialMedia: deleteSocialMediaApi,
    updateSocialMediaStatus: updateSocialMediaStatusApi
}

export default SocialMediaService
